import axios from "@/api/axiosInstance";

export const removePermissionOverride = async (
  employeeUuid: string,
  overrideId: number,
): Promise<void> => {
  await axios.delete(
    `/api/private/admin/employees/${employeeUuid}/permission-overrides/${overrideId}`,
  );
};
